export class PlaceInfo{
    id:number;
    fullAddress:any;

}